import { ActivatedRouteSnapshot, Router } from '@angular/router';

/**
 * Deepest `data.requiredPermission` on the active route tree (matches attorney section routes).
 */
export function getRouteRequiredPermission(route: ActivatedRouteSnapshot): string | null {
  let required: string | null = null;
  let current: ActivatedRouteSnapshot | null = route;
  while (current) {
    const value = current.data['requiredPermission'];
    if (typeof value === 'string') {
      required = value;
    }
    current = current.firstChild;
  }
  return required;
}

export function getRouterRequiredPermission(router: Router): string | null {
  return getRouteRequiredPermission(router.routerState.snapshot.root);
}
